import { createAction } from "@reduxjs/toolkit";
import type { UpdateTimelineEventBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTimelineEvent = createApiThunk<void, UpdateTimelineEventBody>(
  "timelineEvents/updateTimelineEvent",
  async (body: UpdateTimelineEventBody, { extra: { adminRepository } }) => {
    return adminRepository!.updateTimelineEvent(body);
  },
);

export const resetUpdateTimelineEvent = createAction("timelineEvents/resetUpdateTimelineEvent");
